import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}
 // 创建问题
  getData.QAPasks= (data)=>{ 
    return http.post(baseUrl+"/ask/asks/",data)
  }
 // 删除问题
  getData.delPasks= (pk,data)=>{ 
    return http.delete(baseUrl+"/ask/ask/"+pk+"/",data)
  }
 // 创建回答
  getData.QAPanswers= (data)=>{ 
    return http.post(baseUrl+"/ask/answers/",data)
  }
  // 获取单个问题
  getData.QAGask= (pk,data)=>{ 
    return http.get(baseUrl+"/ask/ask/"+pk+"/",{ params:data })
  }
  // 查看全部问题
  getData.QAGAllasks= (data)=>{ 
    return http.get(baseUrl+"/ask/asks/",{ params:data })
  }
  // 全部回答内容
  getData.QAGAllanswer= (data)=>{ 
    return http.get(baseUrl+"/ask/answers/",{ params:data })
  }
  // 删除回答
  getData.QADelanswer= (pk,data)=>{
    return http.delete(baseUrl+"/ask/answer/"+pk+"/",data)
  }
  // 回答点赞
  getData.QAGAlllikeanswer= (data)=>{ 
    return http.post(baseUrl+"/ask/likeanswer/",data)
  }
 // 收藏
  getData.QAPcolask= (data)=>{
    return http.post(baseUrl+"/ask/colask/",data)
  }
  // 创建图片
  getData.QAPapics= (data)=>{ 
    return http.post(baseUrl+"/ask/apics/",data)
  }
  //删除图片
  getData.QADelapic= (pk,data)=>{
    return http.delete(baseUrl+"/ask/apic/"+pk+"/",data)
  }
export default getData


// WEBPACK FOOTER //
// ./src/common/questionAnswering.js